"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _lodash = require("lodash");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var NumberCardWrapper = function NumberCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "showDigitsOnlyWarning", _descriptor, _this);
      _initializerDefineProperty(_this, "incorrectAnswer", _descriptor2, _this);
      _initializerDefineProperty(_this, "correct", _descriptor3, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "revealed",
      get: function get() {
        return this.props.cardState.revealed;
      }
    }, {
      key: "showExpandedTarget",
      get: function get() {
        return !_state.DeckUI.user.hideVocabTargetUntilRevealed || this.props.cardState.revealed;
      }
    }, {
      key: "icons",
      get: function get() {
        var ary = [];
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (this.props.cardState.revealed) {
          ary.push('vocabCard');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        if (!this.props.cardState.revealed && this.props.card.cardType.slug === 'number_options' && !(0, _utils.isBlank)(this.props.card.word.digitSourceText)) {
          ary.push('toggleMultipleChoice');
        }
        return ary;
      }
    }, {
      key: "randomIntWithSpecificLength",
      value: function randomIntWithSpecificLength(numberDigits) {
        return this.randomIntFromInterval(Math.pow(10, numberDigits - 1), Math.pow(10, numberDigits) - 1);
      }
    }, {
      key: "randomIntFromInterval",
      value: function randomIntFromInterval(min, max) {
        // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min);
      }
    }, {
      key: "dateMultipleChoiceSources",
      value: function dateMultipleChoiceSources(correctOption) {
        var _this2 = this;
        var sources = [];
        var randomNumber;
        var shuffledOption;
        // shuffle the digits of correctOption answer (sometimes) except the first digit (ex: 1863, 1683)
        if (new Set(this.props.card.word.digitSourceText.split('')).size > 1 && Math.random() > 0.5) {
          // cannot be shuffled if all digits are identical
          for (var i = 0; i < 10; i++) {
            shuffledOption = correctOption.text[0] + (0, _lodash.shuffle)(correctOption.text.split('').slice(1)).join('').toString();
            if (shuffledOption !== 'NaN' && shuffledOption.length === correctOption.text.length && shuffledOption !== correctOption.text) {
              sources.push(shuffledOption);
            }
            if (sources.length === 1) {
              break;
            }
          }
        }
        var _loop = function _loop() {
          var valueOfDate = parseInt(correctOption.text);
          randomNumber = _this2.randomIntFromInterval(valueOfDate * 0.7, valueOfDate * 1.3).toString();
          if (!(0, _utils.isPresent)(sources.find(function (item) {
            return item === randomNumber;
          })) && randomNumber !== correctOption.text) {
            sources.push(randomNumber);
            // shuffle a wrong answer (sometimes)
            if (sources.length < 3 && new Set(randomNumber.split('')).size > 1 && Math.random() > 0.5) {
              // cannot be shuffled if all digits are identical
              var wrongShuffledOption = randomNumber[0] + (0, _lodash.shuffle)(randomNumber.split('').slice(1)).join('');
              if (wrongShuffledOption !== 'NaN' && !(0, _utils.isPresent)(sources.find(function (item) {
                return item === wrongShuffledOption;
              })) && wrongShuffledOption.length === randomNumber.length && wrongShuffledOption !== correctOption.text) {
                sources.push(wrongShuffledOption);
              }
            }
          }
          if (sources.length === 3) {
            return 1; // break
          }
        };
        for (var _i = 0; _i < 10; _i++) {
          if (_loop()) break;
        }
        return sources;
      }
    }, {
      key: "numberMultipleChoiceSources",
      get: function get() {
        var _this3 = this;
        if (_state.DeckUI.deck.numberDeck && (_state.DeckUI.deck.treeNodesCount > 0 || this.props.card.word.digitSourceText)) {
          var sources = [];
          var correctOption = {
            id: 1,
            text: this.props.card.word.formattedDigitSourceText,
            correct: true
          };
          if (this.props.card.word.isDate) {
            sources = this.dateMultipleChoiceSources(correctOption);
          } else {
            if (_state.DeckUI.deck.treeNodesCount > 0) {
              return (0, _lodash.shuffle)(_state.DeckUI.deck.digitWordsList.filter(function (item) {
                return item && item !== correctOption.text;
              }));
            } else {
              var randomNumber;
              var END_ZEROES_REGEX = /0+$/;
              var EVERYTHING_BUT_ZERO_REGEX = /^[^0]+/;
              if (END_ZEROES_REGEX.test(correctOption.text) && EVERYTHING_BUT_ZERO_REGEX.test(correctOption.text)) {
                var _this$props$card$word, _this$props$card$word2;
                var shuffledOption;
                var endZeroes = (_this$props$card$word = this.props.card.word) === null || _this$props$card$word === void 0 || (_this$props$card$word = _this$props$card$word.digitSourceText) === null || _this$props$card$word === void 0 ? void 0 : _this$props$card$word.match(END_ZEROES_REGEX)[0];
                var correctDigitsWithoutZeroes = (_this$props$card$word2 = this.props.card.word) === null || _this$props$card$word2 === void 0 || (_this$props$card$word2 = _this$props$card$word2.digitSourceText) === null || _this$props$card$word2 === void 0 ? void 0 : _this$props$card$word2.match(EVERYTHING_BUT_ZERO_REGEX)[0];
                // shuffle the digits of correctOption answer (sometimes)
                if (new Set(correctDigitsWithoutZeroes.split('')).size > 1 && Math.random() > 0.5) {
                  // cannot be shuffled if all digits are identical
                  for (var i = 0; i < 10; i++) {
                    shuffledOption = parseInt((0, _lodash.shuffle)(correctDigitsWithoutZeroes.split('')).join('') + endZeroes).toLocaleString('en');
                    if (shuffledOption !== 'NaN' && !shuffledOption.startsWith('0') && shuffledOption !== correctOption.text && shuffledOption.length === correctOption.text.length) {
                      sources.push(shuffledOption);
                    }
                    if (sources.length === 1) {
                      break;
                    }
                  }
                }
                for (var _i2 = 0; _i2 < 10; _i2++) {
                  randomNumber = parseInt(this.randomIntWithSpecificLength(this.props.card.word.digitSourceText.length - endZeroes.length).toString() + endZeroes).toLocaleString('en');
                  if (randomNumber !== 'NaN' && !(0, _utils.isPresent)(sources.find(function (item) {
                    return item === randomNumber;
                  })) && randomNumber !== correctOption.text) {
                    sources.push(randomNumber);
                  }
                  if (sources.length === 3) {
                    break;
                  }
                }
              } else {
                var _shuffledOption;
                // shuffle the digits of correctOption answer (sometimes)
                if (new Set(this.props.card.word.digitSourceText.split('')).size > 1 && Math.random() > 0.5) {
                  // cannot be shuffled if all digits are identical
                  for (var _i3 = 0; _i3 < 10; _i3++) {
                    _shuffledOption = parseInt((0, _lodash.shuffle)(correctOption.text.split('')).join('')).toLocaleString('en');
                    if (_shuffledOption !== 'NaN' && _shuffledOption.length === correctOption.text.length && _shuffledOption !== correctOption.text) {
                      sources.push(_shuffledOption);
                    }
                    if (sources.length === 1) {
                      break;
                    }
                  }
                }
                var _loop2 = function _loop2() {
                  randomNumber = _this3.randomIntWithSpecificLength(_this3.props.card.word.digitSourceText.length).toLocaleString('en');
                  if (!(0, _utils.isPresent)(sources.find(function (item) {
                    return item === randomNumber;
                  })) && randomNumber !== correctOption.text && randomNumber.length === correctOption.text.length) {
                    sources.push(randomNumber);
                    // shuffle a wrong answer (sometimes)
                    if (sources.length < 3 && new Set(randomNumber.split('')).size > 1 && Math.random() > 0.5) {
                      // cannot be shuffled if all digits are identical
                      var wrongShuffledOption = parseInt((0, _lodash.shuffle)(randomNumber.split('')).join('')).toLocaleString('en');
                      if (wrongShuffledOption !== 'NaN' && !(0, _utils.isPresent)(sources.find(function (item) {
                        return item === wrongShuffledOption;
                      })) && wrongShuffledOption.length === randomNumber.length && wrongShuffledOption !== correctOption.text) {
                        sources.push(wrongShuffledOption);
                      }
                    }
                  }
                  if (sources.length === 3) {
                    return 1; // break
                  }
                };
                for (var _i4 = 0; _i4 < 10; _i4++) {
                  if (_loop2()) break;
                }
              }
            }
          }
          return sources;
        }
      }
    }, {
      key: "showTextEntryCard",
      get: function get() {
        return _state.AppUI.user.textInputNumberTrainer && !(0, _utils.isBlank)(this.props.card.word.digitSourceText);
      }
    }, {
      key: "correctAnswer",
      get: function get() {
        return this.props.card.word.digitSourceText;
      }
    }, {
      key: "textInputIsCorrect",
      get: function get() {
        return parseInt(this.props.cardState.textEntry.replace(/\s/, '')) !== NaN && parseInt(this.props.cardState.textEntry.replace(/\s/, '')) === parseInt(this.correctAnswer);
      }
    }, {
      key: "textInputContainsLetters",
      get: function get() {
        return (0, _utils.isPresent)(this.props.cardState.textEntry) && this.props.cardState.textEntry.match(/[^\d\.,\s]/);
      }
    }, {
      key: "onTextInputChange",
      value: function onTextInputChange(val) {
        _state.DeckUI.onWordInputChange(this.props.cardState, val);
        if (_state.DeckUI.user.evaluateVocabOnKeystroke && this.textInputIsCorrect) {
          this.handleCorrectAnswer();
        } else if (_state.DeckUI.user.evaluateVocabOnKeystroke && this.textInputContainsLetters) {
          this.showDigitsOnlyWarning = true;
        } else {
          this.showDigitsOnlyWarning = false;
        }
      }
    }, {
      key: "evaluateTextInput",
      value: function evaluateTextInput() {
        if (this.textInputIsCorrect) {
          this.handleCorrectAnswer();
        } else if (this.textInputContainsLetters && !this.showDigitsOnlyWarning) {
          this.showDigitsOnlyWarning = true;
        } else {
          this.handleIncorrectAnswer();
        }
      }
    }, {
      key: "handleCorrectAnswer",
      value: function handleCorrectAnswer() {
        this.correct = true;
        this.props.userCard.set('score', 1);
        _state.DeckUI.onCorrectAnswer(this.props.card, this.props.cardState, this.props.userCard, {
          xp: 1,
          xpSlug: 'conjugation'
        });
        _state.DeckUI.reveal();
      }
    }, {
      key: "handleIncorrectAnswer",
      value: function handleIncorrectAnswer() {
        this.props.userCard.set('seen', true);
        this.incorrectAnswer = this.props.cardState.textEntry;
        _state.DeckUI.onIncorrectAnswer(this.props.card, this.props.cardState, this.props.userCard);
        _state.DeckUI.reveal();
      }
    }, {
      key: "onClickButton",
      value: function onClickButton(option) {
        var _this4 = this;
        this.clickedAnswer = this.conjugatedVerbStringDisplayValue(option.value);
        if (!_state.DeckUI.user.wasUiElementSeen('conjugation-multiple-choice')) {
          _state.DeckUI.designateUiElementAsSeen('conjugation-multiple-choice');
        }
        this.multipleChoiceSelected = option.id;
        if (option.value === this.correctAnswer) {
          this.handleCorrectAnswer();
        } else {
          this.handleIncorrectAnswer();
        }
        setTimeout(this.clearSelection, 500);
        setTimeout(function () {
          return _state.DeckUI.reveal(_this4.props.card, _this4.props.cardState);
        }, 500);
      }
    }, {
      key: "clearSelection",
      value: function clearSelection() {
        this.multipleChoiceSelected = null;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          correctAnswer: this.correctAnswer,
          incorrectAnswer: this.incorrectAnswer,
          onClickButton: this.onClickButton,
          multipleChoiceSelected: this.multipleChoiceSelected,
          revealed: this.revealed,
          correct: this.correct,
          onTextInputChange: this.onTextInputChange,
          evaluateTextInput: this.evaluateTextInput,
          icons: this.icons,
          showDigitsOnlyWarning: this.showDigitsOnlyWarning,
          clickedAnswer: this.clickedAnswer,
          showTextEntryCard: this.showTextEntryCard,
          showExpandedTarget: this.showExpandedTarget,
          numberMultipleChoiceSources: this.numberMultipleChoiceSources
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showDigitsOnlyWarning", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "incorrectAnswer", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "correct", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "revealed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "revealed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showExpandedTarget", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showExpandedTarget"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "numberMultipleChoiceSources", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numberMultipleChoiceSources"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showTextEntryCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showTextEntryCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputIsCorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputIsCorrect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputContainsLetters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputContainsLetters"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onTextInputChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onTextInputChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "evaluateTextInput", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "evaluateTextInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleCorrectAnswer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "handleCorrectAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleIncorrectAnswer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "handleIncorrectAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClickButton", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClickButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearSelection", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearSelection"), _class2.prototype), _class2)) || _class;
};
NumberCardWrapper.displayName = 'NumberCardWrapper';
var _default = exports["default"] = NumberCardWrapper;